import React from "react";
import { motion } from "framer-motion";

// Big playful CTA button used across the app.
export default function BigButton({ children, onClick, variant = "primary", disabled, className = "", ...rest }) {
    const variants = {
        primary: "bg-terracotta text-white hover:bg-terracottaDark",
        secondary: "bg-white text-charcoal border-2 border-charcoal/10 hover:border-charcoal/30",
        honey: "bg-honey text-charcoal hover:bg-honey/90",
        sage: "bg-sage text-white hover:brightness-95",
        ghost: "bg-transparent text-charcoal hover:bg-white/60",
    };
    return (
        <motion.button
            whileHover={{ scale: disabled ? 1 : 1.03 }}
            whileTap={{ scale: disabled ? 1 : 0.96 }}
            transition={{ type: "spring", stiffness: 320, damping: 22 }}
            onClick={onClick}
            disabled={disabled}
            className={`inline-flex items-center justify-center gap-3 rounded-full px-8 py-4 min-h-[64px] font-display font-semibold text-lg shadow-lg shadow-black/10 disabled:opacity-50 disabled:cursor-not-allowed ${variants[variant]} ${className}`}
            {...rest}
        >
            {children}
        </motion.button>
    );
}
